import { Capacitor } from '@capacitor/core';
import { FeatureFlag, isFeatureEnabled } from 'Utils/FeatureFlags';
import { isCapacitorNative } from 'Utils/Constants';

export const isRepertoireCreateAvailable = () =>
  isFeatureEnabled(FeatureFlag.USE_REPERTOIRE_CREATE) &&
  !(isCapacitorNative() && Capacitor.getPlatform() === 'android');
